// extracted by mini-css-extract-plugin
module.exports = {"search-bar-input":"SearchBar_search-bar-input__jHmyj","stretch":"SearchBar_stretch__z57Wq"};